import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
// import { install } from '@icon-park/vue/es/all'

// install(Vue, 'i')
Vue.component(FeatherIcon.name, FeatherIcon)
